module.exports = __webpack_public_path__ + "img/trolley.cb70dcb0.png";